import React from 'react';
import RedirectUtils from '../../system-utils/redirect-utils';

import { TEXT_ERROR_404_PAGE_BODY, TEXT_ERROR_404_PAGE_HEADER, TEXT_ERROR_404_PAGE_BODY_NO_CONSENT, TEXT_ERROR_404_PAGE_BODY_INLINE, TEXT_ERROR_404_PAGE_BODY_INLINE_NO_CONSENT } from '../ui-component-constants';

import FullPageErrorContent from '../FullPageErrorContent';

type Props = {
  mTrackConsent?: boolean;
  isNativeView?: boolean;
};

export const PageNotFound404: React.FC<Props> = ({ mTrackConsent = true, isNativeView = false }) => {
  const onInlineCtaClick = mTrackConsent ? RedirectUtils.redirectTo9SpokesDashboard : RedirectUtils.redirectToMarketplaceLandingPage;
  const inlineCtaText = mTrackConsent ? TEXT_ERROR_404_PAGE_BODY_INLINE : TEXT_ERROR_404_PAGE_BODY_INLINE_NO_CONSENT;
  const description = mTrackConsent ? TEXT_ERROR_404_PAGE_BODY : TEXT_ERROR_404_PAGE_BODY_NO_CONSENT;
  if (!isNativeView) {
    return <FullPageErrorContent pageTitle={'Page Not Found'} title={TEXT_ERROR_404_PAGE_HEADER} description={description} inlineCtaText={inlineCtaText} onInlineCtaClick={onInlineCtaClick} dataTestId='nba-page-not-found' />;
  }
  return <FullPageErrorContent pageTitle={'Page Not Found'} title={TEXT_ERROR_404_PAGE_HEADER} dataTestId='nba-page-not-found-native' />;
};
